export default __webpack_public_path__ + "static/media/dashboard-icon.03b3cff6.svg";